import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../lib/utils';
import { Logo } from './Logo';
import {
  LayoutDashboard,
  Shield,
  ScrollText,
  Settings,
  ChevronLeft,
  Activity,
  Users
} from 'lucide-react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import logoImage from '../assets/logo.png';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';

const navigation = [
  { name: 'Beranda', href: '/dashboard', icon: LayoutDashboard, roles: ['admin', 'user'] },
  { name: 'Sertifikat', href: '/certificates', icon: Shield, roles: ['admin', 'user'] },
  { name: 'Status Server', href: '/agents', icon: Activity, roles: ['admin'] },
  { name: 'Log Aktivitas', href: '/logs', icon: ScrollText, roles: ['admin'] },
  { name: 'Manajemen User', href: '/users', icon: Users, roles: ['admin'] },
  { name: 'Pengaturan', href: '/settings', icon: Settings, roles: ['admin'] },
];

export function Sidebar({ collapsed, onToggle }) {
  const { user } = useAuth();
  const { branding } = useBranding();

  // Filter navigation based on user role
  const filteredNavigation = navigation.filter(item =>
    item.roles.includes(user?.role || 'user')
  );

  return (
    <div
      className={cn(
        "flex flex-col h-full bg-card border-r transition-all duration-300",
        collapsed ? "w-16" : "w-64"
      )}
    >
      {/* Logo Header */}
      <div className="flex items-center justify-between h-16 px-4 border-b">
        {!collapsed && (
          <div className="flex items-center gap-3">
            <Logo
              src={branding.logo_url || logoImage}
              alt="Logo SSL Monitor"
              size="sm"
            />
            <span className="font-bold text-lg">{branding.header_text}</span>
          </div>
        )}
        {collapsed && (
          <div className="mx-auto">
            <Logo
              src={branding.logo_url || logoImage}
              alt="Logo SSL Monitor"
              size="sm"
            />
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2">
        {filteredNavigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                collapsed && "justify-center"
              )
            }
            title={collapsed ? item.name : undefined}
          >
            <item.icon className="h-5 w-5 flex-shrink-0" />
            {!collapsed && <span>{item.name}</span>}
          </NavLink>
        ))}
      </nav>

      <Separator />

      {/* Toggle Button */}
      <div className="p-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggle}
          className="w-full justify-center"
        >
          <ChevronLeft
            className={cn(
              "h-4 w-4 transition-transform",
              collapsed && "rotate-180"
            )}
          />
        </Button>
      </div>
    </div>
  );
}